import React from "react";

import styles from "./Field.module.scss";

function DescriptionField({ label, description }) {
  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>{label}</label>
      <span className={`d-block ${styles.description}`}>{description}</span>
    </div>
  );
}

export default DescriptionField;
